import { render, staticRenderFns } from "./CmFooter.vue?vue&type=template&id=37b39634&scoped=true&"
import script from "./CmFooter.vue?vue&type=script&lang=ts&"
export * from "./CmFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CmFooter.vue?vue&type=style&index=0&id=37b39634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b39634",
  null
  
)

export default component.exports